import React from 'react';
import styled from 'styled-components';
import Headline2 from '@joinforma/ui/components/Headline2';
import Body1 from '@joinforma/ui/components/Body1';
import Button from '@joinforma/ui/components/Button';

import Modal from '@joinforma/ui/components/Modal';
import HsaIllustration from '@joinforma/ui/assets/illustrations/account-hsa.svg';

import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from '@joinforma/ui/constants/properties';
import { ReactComponent as Close } from '@joinforma/ui/assets/icons/close.svg';
import { COLORS } from '@joinforma/ui/constants/themes';

const StyledModal = styled(Modal)``;

const CloseIcon = styled(Close)`
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 40px;
  right: 40px;

  path {
    stroke: ${COLORS.BLACK_100};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

const StyledHsaIcon = styled.img.attrs({
  src: HsaIllustration,
})`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
`;

const Title = styled(Headline2)`
  margin-bottom: 20px;
`;

const UploadInstructions = styled(Body1)``;

const ContinueButton = styled(Button).attrs({
  size: BUTTON_SIZES.LARGE,
  variant: BUTTON_VARIANTS.PRIMARY,
})``;

interface Props {
  onCancel: () => void;
  visible: boolean;
  bankApplicationFormUrl: string;
}

const CipDocumentUploadModal = ({
  onCancel,
  visible,
  bankApplicationFormUrl,
}: Props) => (
  <StyledModal hide_close_button={true} open={visible} onClose={onCancel}>
    <CloseIcon data-testid="close-button" onClick={onCancel}></CloseIcon>
    <StyledHsaIcon />
    <Title>We need to verify your identity to open your HSA</Title>
    <UploadInstructions>
      We need a little more info to verify your identity. Upload certain
      documents to open your HSA.
    </UploadInstructions>
    <ButtonContainer>
      <a href={bankApplicationFormUrl} target="_blank" rel="noreferrer">
        <ContinueButton>Continue</ContinueButton>
      </a>
    </ButtonContainer>
  </StyledModal>
);

export default CipDocumentUploadModal;
